import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Grid,
    IconButton,
    TextField,
    Typography
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useState } from "react";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import moment from "moment/moment";
import AgGridTable from "../../utilities/AgGridTable";
import ViewPDF from "../order-list/ViewPDF";
import { useTheme } from "@mui/material/styles";

const DeliveryDelay = ({ lvDocumentInfoesList }) => {
    const [expanded, setExpanded] = useState("panel1");
    const [openPDF, setOpenPDF] = useState(false);
    const theme = useTheme();
    const handleAccordionChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    const handleViewPDF = () => {
        setOpenPDF(true);
    };
    const handlePDFClose = () => {
        setOpenPDF(false);
    };
    return (
        <div>
            {lvDocumentInfoesList?.map((item, index) => {
                return (
                    <Accordion
                        key={`Accordion_${item?.id}`}
                        expanded={expanded === `panel${item?.id}`}
                        onChange={handleAccordionChange(`panel${item?.id}`)}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            className="items-center"
                        >
                            <Box
                                sx={{
                                    background: theme.palette.secondary.main,
                                    color: theme.palette.secondary.contrastText,
                                    borderRadius: "100%",
                                    lineHeight: "30px",
                                    width: 30,
                                    textAlign: "center",
                                }}
                            >
                                {index + 1}
                            </Box>
                            <Typography sx={{ px: 2 }}>Positions: {item?.missingItems?.map((item) => item?.posNum)?.join(", ")}</Typography>
                            <Button
                                variant="text"
                                color="secondary"
                                size="small"
                                startIcon={<PictureAsPdfRoundedIcon />}
                                onClick={handleViewPDF}
                            >
                                View : LV_{item?._links?.lvDocumentInfo?.href?.split("/")[item?._links?.lvDocumentInfo?.href.split("/")?.length - 1]?.toUpperCase()}
                            </Button>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={3}>

                                <Grid item sm={6} >
                                    <Typography sx={{ px: 2 }}>Positions: {item?.missingItems?.map((item) => item?.posNum)?.join(", ")}</Typography>
                                    {item?.missingItems ? <Typography sx={{ px: 2 }}>Missing Items: {item?.missingItems?.map((item) => item?.item)?.join(", ")}</Typography> : null}
                                </Grid>
                                <Grid item sm={6}>
                                    <div className="flex flex-col w-full sm:w-auto sm:flex-row flex-1 items-center justify-end">
                                        <FuseSvgIcon size={16}>
                                            heroicons-outline:calendar
                                        </FuseSvgIcon>{" "}
                                        <span className="ml-6"> {
                                            moment(item?.receivedOn)?.format(
                                                "DD-MM-YYYY"
                                            )}</span>
                                    </div>
                                </Grid>
                            </Grid>
                            <ViewPDF open={openPDF} handleClose={handlePDFClose} title={`View ${item?._links?.lvDocumentInfo?.href?.split("/")[item?._links?.lvDocumentInfo?.href.split("/")?.length - 1]?.toUpperCase()}`} />
                        </AccordionDetails>
                    </Accordion>
                )
            })}
        </div>
    )
}
export default DeliveryDelay;